import { Component, OnInit, ViewChild } from '@angular/core';
import { AppInformationService, AuthService, GenesisUnitOfWork, SessionInformationService } from 'app/core/core.module';
import { ConfirmationMessage } from 'app/core/model/confirmation-message';
import { DxDataGridComponent } from 'devextreme-angular';
import { confirm } from 'devextreme/ui/dialog';
import _ from 'lodash';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmationMessageDialogComponent } from '../confirmation-message-dialog/confirmation-message-dialog.component';

@Component({
    selector: 'app-confirmation-message',
    templateUrl: './confirmation-message.component.html',
    styleUrls: ['./confirmation-message.component.scss'],
    standalone: false
})
export class ConfirmationMessageComponent implements OnInit {
    messages: any;
    showAllOrders = false;
    previewOpen = false;
    filter: any;
    confirmationTypes: any[];
    confirmationInfo: any;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

    constructor(
        private uow: GenesisUnitOfWork,
        public auth: AuthService,
        private appInfo: AppInformationService,
        private modalService: BsModalService,
        private sessionInfo: SessionInformationService
    ) {}

    async ngOnInit() {
        // const dealers = await this.uow.getDealers();
        // this.confirmationTypes = this.uow.lookups.confirmationTypes;
        this.confirmationInfo = {};
        this.filter = this.sessionInfo.getItem('confirmation-message-filter') ?? { showArchived: false };
        await this.getData();
    }

    async getData() {
        const messages = await this.uow.getConfirmationMessages(this.filter.showArchived);
        this.messages = messages;
        this.sessionInfo.setItem('confirmation-message-filter', this.filter);
    }

    async toggleShowArchived() {
        this.dataGrid.instance.clearSelection();
        this.filter.showArchived = !this.filter.showArchived;
        await this.getData();
    }

    async toggleArchived(messages: ConfirmationMessage[]) {
        if (!messages || messages.length === 0) return;

        this.appInfo.pleaseWaitShow();

        const toggle = _.some(messages, 'archived');
        messages.forEach((message) => {
            if (toggle) message.archived = null;
            else message.archived = new Date();
        });
        this.dataGrid.instance.clearSelection();
        this.confirmationInfo = {};
        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    // this method is used to clear the selection when the user searches for something
    onOptionChanged(e) {
        if (e.fullName === 'searchPanel.text') {
            e.component.__searchChanged = true;
        }
        const filterCheck = _.includes(e.fullName, 'filterValue');
        if (filterCheck) {
            this.dataGrid.instance.clearSelection();
        }
    }

    // this method is used to clear the selection when the user searches for something
    onContentReady(e) {
        if (e.component.__searchChanged) {
            //__searchChanged is for the search box
            e.component.__searchChanged = false;
            this.dataGrid.instance.clearSelection();
        }
    }

    selectionChange(e) {
        console.log(e);
        if (e.selectedRowsData && e.selectedRowsData.length > 0) {
            this.confirmationInfo.Message = e.selectedRowsData[0].message;
            this.confirmationInfo.Message2 = e.selectedRowsData[0].message2;
        }
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async rowDoubleClick(e) {
        if (!e.data || !e.data.id) return;
        await this.open(e.data);
    }

    async open(message?: any) {
        const modalRef = this.modalService.show(ConfirmationMessageDialogComponent, {
            class: 'modal-mdw',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                message: message,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                this.appInfo.pleaseWaitShow();
                await this.uow.commit();
                await this.getData();
                this.appInfo.pleaseWaitHide();
            }
            modalRef.hide();
        });
    }

    async delete(message: ConfirmationMessage) {
        if (!message || !message.id) return;
        const result = await confirm('Are you sure you want to delete the message?', 'Delete Message');
        if (!result) return;

        this.appInfo.pleaseWaitShow();
        message.deleted = new Date();
        this.confirmationInfo = {};
        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }
}
